"use client";

import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { fetchServices } from "@/store/slices/landingSlice";
import Loader from "@/components/Loader";
import ServicesSection from "@/views/ServicesSection";
import AboutPreviewSection from "@/views/AboutPreviewSection";
import PortfolioSection from "@/views/PortfolioSection";
import TestimonialsSection from "@/views/TestimonialsSection";
import WhyChooseUsSection from "@/views/WhyChooseUsSection";
import FAQSection from "@/views/FAQSection";
import CallToActionSection from "@/views/CallToActionSection";
import { HeroParallaxDemo } from "@/views/HeroParallaxDemo";

const HomeClient = () => {
  const dispatch = useAppDispatch();
  const { data: services } = useAppSelector((state) => state.landing.services);
  const { mode } = useAppSelector((state) => state.theme);
  const [showFirstVisitLoader, setShowFirstVisitLoader] = useState(false);

  useEffect(() => {
    dispatch(fetchServices());

    if (typeof window === "undefined") {
      return;
    }

    const hasSeenHomeLoader = window.localStorage.getItem("home-first-visit-loader-seen");
    if (!hasSeenHomeLoader) {
      setShowFirstVisitLoader(true);
    }
  }, [dispatch]);

  const handleCloseFirstVisitLoader = () => {
    setShowFirstVisitLoader(false);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("home-first-visit-loader-seen", "true");
    }
  };

  return (
    <main className="overflow-hidden">
      <Loader
        loading={showFirstVisitLoader}
        services={services}
        mode={mode}
        duration={1600}
        closeable
        persistUntilClose
        fullscreen
        lockScrollWhenVisible
        onClose={handleCloseFirstVisitLoader}
      />
      <HeroParallaxDemo />
      <ServicesSection />
      <AboutPreviewSection />
      <PortfolioSection />
      <TestimonialsSection />
      <WhyChooseUsSection />
      <FAQSection />
      <CallToActionSection />
    </main>
  );
};

export default HomeClient;
